import Body from '@/components/body';
import Header from '@/components/header';
import '../scss/root.scss';
import { history, LoadingBar, useArticle, useBook, useFile } from 'topwrite';
import { SidebarProvider } from '@/lib/use-sidebar';
import { PartProvider } from '@/lib/use-part';
import { useEffect } from 'react';

export default function Root() {

    const file = useFile();
    const { summary } = useBook();

    const article = useArticle();

    useEffect(() => {
        if (!article) {
            const firstPath = summary.getFirstPath();
            if (firstPath) {
                history.replace(file.relative(firstPath));
            }
        }
    }, [article]);

    if (!article) {
        return null;
    }

    return <SidebarProvider>
        <LoadingBar />
        <PartProvider>
            <Header />
            <Body />
        </PartProvider>
    </SidebarProvider>;
}
